module.exports = __webpack_public_path__ + "static/img/lv.8b293d98.svg";